import { combineReducers } from 'redux';
import { SIDEBAR_ITEMS, SIDEBAR_OPEN, MOBILEMENU_EXPANDED, USERMENU_LAYOUT, ACTIVE_TASKID, DRAWER_OPEN, } from './types';
// action
var sidebarItems = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case SIDEBAR_ITEMS:
            return action.paylaod;
        default:
            return state;
    }
};
var sidebarOpen = function (state, action) {
    if (state === void 0) { state = true; }
    switch (action.type) {
        case SIDEBAR_OPEN:
            return !action.paylaod;
        default:
            return state;
    }
};
var mobileMenuExpanded = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case MOBILEMENU_EXPANDED:
            return action.paylaod;
        default:
            return state;
    }
};
var userMenuLayouts = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case USERMENU_LAYOUT:
            return action.paylaod;
        default:
            return state;
    }
};
var activeTaskId = function (state, action) {
    if (state === void 0) { state = window.sessionStorage.getItem('userUsingTask') || ''; }
    switch (action.type) {
        case ACTIVE_TASKID:
            return action.paylaod;
        default:
            return state;
    }
};
var drawerOpen = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case DRAWER_OPEN:
            return !action.paylaod;
        default:
            return state;
    }
};
export var SCOPE_NAME = 'LAYOUT';
var LAYOUT = combineReducers({
    sidebarItems: sidebarItems,
    sidebarOpen: sidebarOpen,
    mobileMenuExpanded: mobileMenuExpanded,
    userMenuLayouts: userMenuLayouts,
    activeTaskId: activeTaskId,
    drawerOpen: drawerOpen,
});
export default LAYOUT;
